import Button from '@shared/components/core/button/CoreButton';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export default function LicenseKeyEmptyBanner() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <PageBannerCard
            description={t('common:license.key.empty.description')}
            fullHeight
            title={t('common:license.key.empty.title')}>
            <Button onClick={() => navigate('../purchase')} startIcon="plusLight">
                {t('common:license.key.product.title')}
            </Button>
        </PageBannerCard>
    );
}
